import React from "react";
import { Link } from "react-router-dom";
import "./Hero.css";
import heroConfig from "../../../config/home.json";

const HeroSection = () => {
  const backgroundImage =
    "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/New-Gladiators-Logo.jpg";
  return (
    <section
      className="hero-section"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <span className="hero-eyebrow">Bournemouth · Est. 2022</span>
        <h1 className="hero-title">{heroConfig.hero.title}</h1>
        <p className="hero-subtitle">{heroConfig.hero.subTitle}</p>
        <div className="hero-actions">
          <Link to="/team" className="hero-btn hero-btn-primary">
            Meet the Team
          </Link>
          <Link to="/contact" className="hero-btn hero-btn-ghost">
            Join Us
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
